module.exports = __webpack_public_path__ + "img/i_empty_n.ea070074.svg";